// extracted by mini-css-extract-plugin
module.exports = {"sHomePageContent":"sHomePageContent_sHomePageContent__6zzg6","sInstructorSlider":"sHomePageContent_sInstructorSlider__Kj1a4"};